/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [home-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 06.10.18 15:48
 */

import React, {useEffect} from 'react';
import Sidebar from '../components/billboard-sidebar/sidebar';
import Chat from "../views/friends-view/chat";
import Friends from "../views/friends-view/friends";
import HomeNavigation from "../components/billboard-navigation/home/home-navigation";
import {useAuthorization, useFriendData} from "../selectors";
import {Redirect, useHistory, useLocation, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {asyncFetchFriends, asyncFetchFriendsPending, localOpenFriendChat} from "../actions";
import {useIsMobile, useLanguage} from "../components/configuration/configuration";
import {notifyWarning} from "../components/notifications/notify";

export const FriendsMobileChat = () => {
    const location = useLocation();
    const {username} = useParams();
    const {friend: friendChat} = useFriendData();
    const history = useHistory();
    const {isAuthorized} = useAuthorization();
    const Lang = useLanguage();

    if(!friendChat) history.goBack();

    if(!isAuthorized) {
        notifyWarning(Lang.access.mustLogin.text);
        return <Redirect to='/login'/>
    }

    return <div className='home-space-container'>
        <div className='row'>
            <div className='col-sm-9'>
                <HomeNavigation username={username} location={location}/>
                {friendChat && <div className='box-light-gray'>
                    <Chat/>
                </div>}
            </div>
            <div className='col-sm-3'>
            </div>
        </div>
    </div>
}

const FriendsSpace = () => {
    const location = useLocation();
    const {username} = useParams();
    const {friend: friendChat} = useFriendData();
    const history = useHistory();
    const {isAuthorized} = useAuthorization();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();

    // fetch friends from url and not from authorized user
    useEffect(() => {
        dispatch(asyncFetchFriends(username));

        // reset current open chat
        return () => {
            if(!isMobile) {
                dispatch(localOpenFriendChat(null));
            }
        }
    }, [isAuthorized, username]);

    // fetch pending requests from url and not from authorized user
    useEffect(() => {
        dispatch(asyncFetchFriendsPending(username));
    }, [isAuthorized, username]);

    const renderMobileMode = () => {
        return <div className='home-space-container'>
            <div className='row'>
                <div className='col-sm-9'>
                    <HomeNavigation username={username} location={location} className='home-navigation'/>
                    <div className='box-white'>
                        <Friends username={username} location={location}/>
                    </div>
                </div>
                <div className='col-sm-3'>
                </div>
            </div>
        </div>
    }

    // TODO need to rework this stuff with container class
    // return <div className='container home-space-container'>

    const renderDesktopMode = () => {
        return <div className='home-space-container'>
            <div className='row'>
                <div className='col-sm-9'>
                    <HomeNavigation username={username} location={location} rounded/>
                    <div className='row'>
                        <div className='col-sm-4'>
                            <Friends username={username} location={location}/>
                        </div>
                        <div className='col-sm-8'>
                            <Chat/>
                        </div>
                    </div>
                </div>

                <div className='col-sm-3'>
                    {!isMobile && <Sidebar username={username} location={location}/>}
                </div>
            </div>
        </div>
    }

    if (isMobile && friendChat) {
        history.push(location.pathname + '/chat');
        return null;
    }
    return isMobile ? renderMobileMode() : renderDesktopMode();
}

export default FriendsSpace;